var exports = {
  "Un": "errorContainer__CcZFtc",
};

module.exports = exports;
